<ng-container *transloco="let t;">
    <form [formGroup]="filterForm" (ngSubmit)="applyFilter()">
        <div class="row">
            <div class="col-xl-12 col-md-12 col-12 mb-0">
                <div class="form-group">
                    <label for="{{item?.item?.meta_data_name + '_date_from'}}">{{ t('Advanced filter start date label (Advanced filters) - start date') }}</label>
                    <div class="col-12 p-0 CC_datePicker">
                        <input id="{{item?.item?.meta_data_name + '_date_from'}}" type="text" mwlFlatpickr
                               class="form-control" [value]="fromDate"
                               (change)="fromDateChanged($event)" [options]="flatpickrConfig"
                               [convertModelValue]="true"/>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-12 col-md-12 col-12 mb-0">
                <div class="form-group">
                    <label for="{{item?.item?.meta_data_name + '_date_to'}}">{{ t('Advanced filter end date label (Advanced filters) - end date') }}</label>
                    <div class="col-12 p-0 CC_datePicker">
                        <input id="{{item?.item?.meta_data_name + '_date_to'}}" type="text" mwlFlatpickr
                               class="form-control" [value]="toDate"
                               (change)="toDateChanged($event)" [options]="flatpickrConfig" [convertModelValue]="true"/>
                    </div>
                </div>
            </div>
        </div>
        <hr/>
        <button type="button" class="btn btn btn-primary btn-sm w-100"
                (click)="applyFilter()">{{ t('Apply filter button name (Advanced filters) - Done') }}
        </button>
    </form>
</ng-container>